<template>
  <div id="app">
    <div id="company-heading">
      <img src="./assets/logo.png">
      <h1>Atory Co., Ltd.</h1>
      <h2>Digital Transformation Business</h2>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 64rem;
  margin: 60px auto 0;
}

#company-heading {
  text-align: center;
  margin-bottom: 75px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue